import { useContext, useEffect, useState } from 'react';
import ErrorAlert from '../../atoms/ErrorAlert/ErrorAlert';
import LabelledComboBox from '../../atoms/LabelledComboBox/LabelledComboBox';
import Spinner from '../../atoms/Spinner/Spinner';
import WideButton from '../../atoms/WideButton/WideButton';
import { IListData } from '../../../services/GiftsApi';
import GlobalVariablesContext from '../../contexts/GlobalVariablesContext';
import Dialog from '../Dialog/Dialog';
import './CopyGiftDialog.scss';

interface CopyGiftDialogProps {
    listId: number;
    giftId: number;
    onCopied: () => void;
    onCancel: () => void;
}

const CopyGiftDialog = (props: CopyGiftDialogProps) => {

    const { giftsApi } = useContext(GlobalVariablesContext);

    const [loadingLists, setLoadingLists] = useState(true);

    const [error, setError] = useState('');

    const [availableLists, setAvailableLists] = useState<IListData[]>([]);

    const [list, setList] = useState(-1);

    const handleCopyButtonClick = async () => {
        await giftsApi
            .copyGift(props.listId, props.giftId, list)
            .then(data => {
                props.onCopied();
            })
            .catch(error => {
                setError(error.response.data.error);
            });
    }

    const handleCancelButtonClick = () => {
        props.onCancel();
    }

    const loadLists = async () => {
        setLoadingLists(true);
        setAvailableLists([]);
        await giftsApi
            .getLists()
            .then(data => {
                setLoadingLists(false);
                setError('');
                setAvailableLists(data.data);
            })
            .catch(error => {
                setLoadingLists(false);
                setError(error.response.data.error);
            });
    }

    useEffect(() => {
        loadLists();
    }, []);

    return (
        <Dialog className="copy-gift-dialog" onClose={handleCancelButtonClick}>

            <h1>Copy Gift</h1>

            {loadingLists && <Spinner />}

            {!loadingLists &&
                <>
                    <LabelledComboBox name="list" label="Copy this gift where?" onChange={e => setList(parseInt(e.target.value))}
                        options={availableLists.map(l => { return { value: l.id.toString(), label: l.name } })} />

                    {error && <ErrorAlert title='Cannot Load Lists' message={error} />}

                    <WideButton label='Copy' onClick={() => handleCopyButtonClick()} />

                    <WideButton label='Cancel' variant='red' onClick={() => handleCancelButtonClick()} />
                </>
            }

        </Dialog>
    );
}

export default CopyGiftDialog;